import _definePage_default_0 from '/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/[...path].vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/account.vue?definePage&vue&lang.tsx'
import _definePage_default_3 from '/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/admin/index.vue?definePage&vue&lang.tsx'
import _definePage_default_4 from '/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/admin/taken/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_5 from '/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/admin/taken/nieuwe-taak.vue?definePage&vue&lang.tsx'
import _definePage_default_6 from '/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/client/index.vue?definePage&vue&lang.tsx'
import _definePage_default_7 from '/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/client/taken/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_8 from '/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/inloggen.vue?definePage&vue&lang.tsx'
import _definePage_default_9 from '/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/registreren.vue?definePage&vue&lang.tsx'
import _definePage_default_10 from '/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/wachtwoord-instellen-[hash]-[userId].vue?definePage&vue&lang.tsx'
import _definePage_default_11 from '/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/wachtwoord-vergeten.vue?definePage&vue&lang.tsx'

export const routes = [
  _mergeRouteRecord(
    {
      path: '/:path(.*)',
      name: '/[...path]',
      component: () => import('/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/[...path].vue'),
      /* no children */
    },
    _definePage_default_0
  ),
  _mergeRouteRecord(
    {
      path: '/account',
      name: '/account',
      component: () => import('/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/account.vue'),
      /* no children */
    },
    _definePage_default_2
  ),
  {
    path: '/admin',
    /* internal name: '/admin' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/admin/',
          component: () => import('/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/admin/index.vue'),
          /* no children */
        },
        _definePage_default_3
      ),
      {
        path: 'taken',
        /* internal name: '/admin/taken' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: ':id',
              name: '/admin/taken/[id]',
              component: () => import('/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/admin/taken/[id].vue'),
              /* no children */
            },
            _definePage_default_4
          ),
          _mergeRouteRecord(
            {
              path: 'nieuwe-taak',
              name: '/admin/taken/nieuwe-taak',
              component: () => import('/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/admin/taken/nieuwe-taak.vue'),
              /* no children */
            },
            _definePage_default_5
          )
        ],
      }
    ],
  },
  {
    path: '/client',
    /* internal name: '/client' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/client/',
          component: () => import('/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/client/index.vue'),
          /* no children */
        },
        _definePage_default_6
      ),
      {
        path: 'taken',
        /* internal name: '/client/taken' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: ':id',
              name: '/client/taken/[id]',
              component: () => import('/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/client/taken/[id].vue'),
              /* no children */
            },
            _definePage_default_7
          )
        ],
      }
    ],
  },
  _mergeRouteRecord(
    {
      path: '/inloggen',
      name: '/inloggen',
      component: () => import('/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/inloggen.vue'),
      /* no children */
    },
    _definePage_default_8
  ),
  {
    path: '/instellingen',
    name: '/instellingen',
    component: () => import('/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/instellingen.vue'),
    /* no children */
  },
  {
    path: '/over-deze-app',
    name: '/over-deze-app',
    component: () => import('/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/over-deze-app.vue'),
    /* no children */
  },
  _mergeRouteRecord(
    {
      path: '/registreren',
      name: '/registreren',
      component: () => import('/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/registreren.vue'),
      /* no children */
    },
    _definePage_default_9
  ),
  _mergeRouteRecord(
    {
      path: '/wachtwoord-instellen-:hash-:userId',
      name: '/wachtwoord-instellen-[hash]-[userId]',
      component: () => import('/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/wachtwoord-instellen-[hash]-[userId].vue'),
      /* no children */
    },
    _definePage_default_10
  ),
  _mergeRouteRecord(
    {
      path: '/wachtwoord-vergeten',
      name: '/wachtwoord-vergeten',
      component: () => import('/app/projects/zie/resources/vueapps/ziezorgapp/src/pages/wachtwoord-vergeten.vue'),
      /* no children */
    },
    _definePage_default_11
  )
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

